export {
  BrandPage as default,
  getJaecooStaticProps as getStaticProps,
} from '@cinch-nx/landing-feature-brand-page'
